import { ActionTypes } from 'Actions/actions';

export const setDomainConfig = (config: any) => ({
	type: ActionTypes.SET_DOMAIN_CONFIG,
	payload: config,
});
